const SESSION_KEY = "sa_session";

export function getSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setSession({ username, token, apiKey }) {
  const existing = getSession() || {};
  sessionStorage.setItem(
    SESSION_KEY,
    JSON.stringify({
      ...existing,
      ...(username !== undefined && { username }),
      ...(token !== undefined && { token }),
      ...(apiKey !== undefined && { apiKey }),
    })
  );
}

export function clearSession() {
  sessionStorage.removeItem(SESSION_KEY);
}

export function isAuthenticated() {
  const session = getSession();
  return Boolean(session?.token || (session?.username && session?.apiKey));
}
